import type { SvgIconComponent } from "@mui/icons-material";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import StorefrontOutlinedIcon from "@mui/icons-material/StorefrontOutlined";
import InsightsOutlinedIcon from "@mui/icons-material/InsightsOutlined";

export type WelcomeFeature = {
  id: string;
  icon: SvgIconComponent;
  titleKey: string;
  titleFallback: string;
  bodyKey: string;
  bodyFallback: string;
};

export const WELCOME_FEATURES: WelcomeFeature[] = [
  {
    id: "inventory",
    icon: Inventory2OutlinedIcon,
    titleKey: "welcome-features-inventory-title",
    titleFallback: "Inventory & catalog",
    bodyKey: "welcome-features-inventory-body",
    bodyFallback:
      "Manage products, categories, and stock across locations with clear product-item tracking."
  },
  {
    id: "orders",
    icon: ShoppingCartOutlinedIcon,
    titleKey: "welcome-features-orders-title",
    titleFallback: "Orders & sales",
    bodyKey: "welcome-features-orders-body",
    bodyFallback:
      "Record sales and purchases, generate receipts and invoices, and keep transactions organized."
  },
  {
    id: "stores",
    icon: StorefrontOutlinedIcon,
    titleKey: "welcome-features-stores-title",
    titleFallback: "Multi-store teams",
    bodyKey: "welcome-features-stores-body",
    bodyFallback:
      "Run multiple stores with role-based access so the right people manage the right locations."
  },
  {
    id: "insights",
    icon: InsightsOutlinedIcon,
    titleKey: "welcome-features-insights-title",
    titleFallback: "Dashboards & insights",
    bodyKey: "welcome-features-insights-body",
    bodyFallback:
      "Monitor revenue, inventory movement, and performance metrics to guide daily decisions."
  }
];

/** First N FAQ items shown on the welcome page preview. */
export const WELCOME_FAQ_PREVIEW_COUNT = 4;
